define([
	"dojo/_base/declare",
	"csi/action/FormData",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/DesignatedSupplierMixin",
	"Apparel/ProductType",
	"./PurchasedOrderForm"
], function(declare,FormData,New,ActionControllerMixin,xml,Query,DesignatedSupplierMixin,ProductType) {

	return declare([New, ActionControllerMixin,DesignatedSupplierMixin], {
		// Boolean: indicate that user should land on new node after node is created
		bNavigate: true,

		// Boolean: indicates if need to refresh second page of wizard when color setting changes
		_bRefreshSecondPage: false,

		// Boolean: this controller overrides default writing of operations
		_bWrite: false,

		// FormData: form data storing
		_fdZero: null,
		_fdOne: null,

		// Node: the Product to create PO for.
		_nodeProduct: null,

		// int: index of the second page of the wizard.
		_secondPageIndex: 1,

		preProcess: function() {
			this._fdZero = this.getFormData();
			this._fdOne = new FormData(this);
			this._fdOne.setNode(this._nodeProduct);

			this.inherited(arguments);
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if on first page
			return !index;
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if not on first page
			return !!index;
		},

		getFormData: function() {
			var	fd = this.inherited(arguments);
			fd.m_parentNode = this._nodeProduct = this.m_cache.getNode(this.m_urlParent);
			fd.m_bRequireOne = true;
			return fd;
		},

		getWizardNumberOfRealizedPages: function(/*csi.wizard.Widget*/wizard) {
			// summary: override when wizard skips pages based on certain conditions and return the number of pages in wizard (must be constant)
			return 2;
		},

		getWizardRealizedPageIndex: function(/*csi.wizard.Widget*/wizard, /*Number*/index) {
			// summary: the first page is always shown, while only one of the 2nd or 3rd pages is shown based on color based ordering
			return index ? 1 : 0;
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for ProductColor
			if (index == 1)
				return new Query().Attr("Active", xml.OP_EQUALS, true);

			return null;
		},

		onPrevPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/prevPage) {
			// summary: second page of wizard can actually be 2nd or 3rd tab in wizard
			var	dfd;

			if (wizard.getIndexOfPage(prevPage) > 0) {
				dfd = wizard.skipToPrevPage(prevPage);
			}

			return dfd;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: second page of wizard can actually be 2nd or 3rd tab in wizard
			var	currentPageIndex = wizard.getIndexOfPage(currentPage);
			var	nextPageIndex = wizard.getIndexOfPage(nextPage);
			var	fd;
			var	dfd;

			// if product type does not support colors, then do not allow color-based ordering
			if (nextPageIndex == 0) {
				fd = this._fdZero;
				if (!ProductType.hasColor(this._nodeProduct)) {
					nextPage.getView(wizard).addFixedValue("OrdersByColor", false);
				}
				return wizard.setFormDataToPage(nextPage, fd, false);
			}

			// setup form data
			if (currentPageIndex == 0) {
				var prevIndex = this._secondPageIndex;

				fd = this._fdOne;
				this._secondPageIndex = this._fdZero.getFieldValue("OrdersByColor") ? 1 : 2;

				if (prevIndex != this._secondPageIndex) {
					// store refresh setting in case need to skip next page
					this._bRefreshSecondPage = true;
					fd.resetSelections();
				}
			}

			if (!bFinish) {
				if (nextPageIndex < this._secondPageIndex) {
					return wizard.skipToNextPage(nextPage);
				}

				dfd = wizard.setFormDataToPage(nextPage, fd, this._bRefreshSecondPage);
				this._bRefreshSecondPage = false;

			}

			return dfd;
		},

		onWizardViewCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view) {
			if (wizard.getIndexOfPage(page) == 0) {
				//initialize designated supplier
				this.initializeDPS(view, "POSupplier");
			}
		},

		toWriter: function() {
			this.inherited(arguments);

			var	call = this.m_writer.callMethod("Sourcing", "POAddProducts")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);

			// add selected nodes - separated into own function so derived controllers can process them differently
			this.toWriterSelections(this._fdOne, call, null);

			return null;
		}
	});
});